module.exports = __webpack_public_path__ + "static/logo-white-e934b17bc1169ed01927d1b97c38cb59.svg";